import { createSvgComponent } from "../../icon/createSvgComponent";
import StarTag from "@core/icon/assets/star-tag.svg";
export default createSvgComponent(StarTag);